import { render } from "./audio-player.vue?vue&type=template&id=0d9ac420&ts=true"
import script from "./audio-player.vue?vue&type=script&lang=ts"
export * from "./audio-player.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__